/* this file is auto-generated.  DO NOT MODIFY*/
import Accordion from '../../src/js/modules/Accordion.js';
import Disclaimer from '../../src/js/modules/Disclaimer.js';
import DrilldownMenu from '../../src/js/modules/DrilldownMenu.js';
import Filter from '../../src/js/modules/Filter.js';
import InfoNumber from '../../src/js/modules/InfoNumber.js';
import LetterIndexScroller from '../../src/js/modules/LetterIndexScroller.js';
import MainMenu from '../../src/js/modules/MainMenu.js';
import OpenPersonModal from '../../src/js/modules/OpenPersonModal.js';
import OpenYoutubeModal from '../../src/js/modules/OpenYoutubeModal.js';
import OrangeCookie from '../../src/js/modules/OrangeCookie.js';
import ResponsivePlaceholder from '../../src/js/modules/ResponsivePlaceholder.js';
import Rte from '../../src/js/modules/Rte.js';
import SearchBox from '../../src/js/modules/SearchBox.js';
import SearchResults from '../../src/js/modules/SearchResults.js';
import Slider from '../../src/js/modules/Slider.js';
import StickyHeader from '../../src/js/modules/StickyHeader.js';
import Timeline from '../../src/js/modules/Timeline.js';
import ToolTip from '../../src/js/modules/ToolTip.js';
import VacancySticky from '../../src/js/modules/VacancySticky.js';

export default [
		Accordion,
		Disclaimer,
		DrilldownMenu,
		Filter,
		InfoNumber,
		LetterIndexScroller,
		MainMenu,
		OpenPersonModal,
		OpenYoutubeModal,
		OrangeCookie,
		ResponsivePlaceholder,
		Rte,
		SearchBox,
		SearchResults,
		Slider,
		StickyHeader,
		Timeline,
		ToolTip,
		VacancySticky
	];

